var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 421,
    viewBox: "0 0 1280 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M-14.1715 357.688C-18.0711 256.786 53.8556 168.804 153.519 152.567L1070.35 3.19564C1195.85 -17.2511 1308.32 83.0714 1302.29 210.083L1293.05 404.491C1287.98 511.138 1200.04 595 1093.28 595H187.42C79.968 595 -8.28134 510.095 -12.431 402.724L-14.1715 357.688Z",
    fill: "url(#paint0_linear_1_3)",
    style: {
      mixBlendMode: "saturation"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3",
    x1: 85.6328,
    y1: 445.053,
    x2: 1071.75,
    y2: 228.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068474,
    stopColor: "#020528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312607,
    stopColor: "#262B69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632918,
    stopColor: "#8A5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832087,
    stopColor: "#EE8042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FF8901"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg1.f577e8e4fc02a2fdf6b2e73ff555f394.svg";
export { ForwardRef as ReactComponent };